/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import { TicketType, TicketListRequest, Ticket, TicketStatus, TicketGroup, TicketUserType} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {TicketService} from "../../services/TicketService";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {SelectInput} from "../form/SelectInput";
import {ColumnType} from "../list/list/ColumnType";
import { isNumber } from "lodash";



interface State extends ListViewState<TicketListRequest> {
    listRequest?: TicketListRequest;
    form?: TicketListRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
}

export class TicketListView extends ListView<State, TicketListRequest> implements FormListener<TicketListRequest>{

    columns = [
        { property: "id", name : "Ticket ID"},
        { property: "requested_by", name: "User ID"},
        { property: "timestamp", name : "Created", type : ColumnType.DATE, orderBy: "timestamp"},
        { property: "status", name: "Status", type: ColumnType.ENUM },
        { property: "groups", name: "Assigned", type: ColumnType.ENUM,renderer: (property: string, name: string, item: any) => {
            return item['groups'] !== undefined && item['groups'].length >0 ? item['groups'].join(",") : "";
        }},
        { property: "type", name : "Issue Type", type: ColumnType.ENUM},
        { property: "subject", name : "Subject"},
        { property: "sender_type ", name : "Last Message", 
            renderer: (property: string, name: string, item: any) => {
                if (item["conversations"]  &&   item["conversations"].length > 0)
                    return <span>
                                {
                                    item["conversations"][item["conversations"].length-1]["sender_type"] === "ADMIN" && (
                                        <button className={"btn"} style={{backgroundColor:"green", width:20,height:20}} />
                                    )
                                    
                                }
                                {
                                    item["conversations"][item["conversations"].length-1]["sender_type"] === "PLAYER" && (
                                        <button className={"btn"} style={{backgroundColor:"red", width:20,height:20}} />
                                    )
                                    
                                }
                            </span>
                else
                    return <span>{}</span>
            }
        },
        { property: "updated_timestamp", name : "Updated", type : ColumnType.DATE, orderBy: "updated_timestamp"},
        { property: "requestor_review_timestamp", name : "Reviewed", type : ColumnType.DATE}
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/ticket/" + item.id }

    ];
    service: TicketService;

    constructor(props : ListViewProps){
        super(props, "/tickets/list");
        this.service = getContainer().getTicketService();

        let locProp = this.props.location;
        if (this.state.listRequest){
            let types: TicketType[] | undefined = undefined;
            let status: TicketStatus[] = [TicketStatus.PENDING, TicketStatus.IN_PROGRESS, TicketStatus.WAITING_FOR_CUSTOMER, TicketStatus.RESOLVED];
            let groups: TicketGroup[] | undefined = undefined;
            let lookupExpanded: boolean = false;

            if(locProp.state && locProp.state.listRequest) {
                types = locProp.state.listRequest.type && locProp.state.listRequest.types;
                status = locProp.state.listRequest.status && locProp.state.listRequest.statuses;
                groups = locProp.state.listRequest.groups && locProp.state.listRequest.groups;
            }
            if(locProp.state && locProp.state.lookupExpanded !== undefined) {
                lookupExpanded = locProp.state.lookupExpanded;
            }
            this.state = createInitialState(
                {
                    limit: 20,
                    orderBy: "timestamp",
                    types: types,
                    statuses: status,
                    groups: groups,
                    start_date: null,
                    end_date: null,
                    ascending: false,
                    searchByDate: true,
                },
                this.state = {lookupExpanded: lookupExpanded,...this.state });
        }
    }
    onSubmit(): void {
        let listRequest: TicketListRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        if (listRequest.id === undefined || listRequest.id === "" || listRequest.id.length === 0){ 
            listRequest.id = undefined; 
        }
        if (listRequest.submitted_by===undefined){listRequest.submitted_by_type=undefined;}
        if (listRequest.types && listRequest.types.length === 0){ listRequest.types = undefined; }
        if (listRequest.statuses && listRequest.statuses.length === 0 ){ listRequest.statuses = undefined; }
        if (listRequest.groups && listRequest.groups.length === 0){ listRequest.groups = undefined; }
        if( listRequest.submitted_by_type===undefined && listRequest.submitted_by!==undefined){
            listRequest.submitted_by_type = TicketUserType.ADMIN;
        }
        this.setState({listRequest:listRequest});
    }

    onSubmitError() :  void {
        console.log("submit error!")
    }

    formDidUpdate(formModel: TicketListRequest, validationMap?: any): void {
        if (formModel.id === "") delete formModel.id;
        if (formModel.orderBy === undefined) formModel.orderBy = "timestamp";
        if (formModel.ascending === undefined) formModel.ascending = false;
        
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item: Ticket, action : string) : Promise<any> | undefined {
       if(item.id && (action === "block" || action === "unblock")) {
           return this.service.setBlocked(item.id);
       }
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            //this.updateListState(listRequest);
            this.setState({listRequest:listRequest});
        }
    }

    getTitle() {
        return "List Tickets"
    }

    preset(preset: "day" | "week" | "month") {

        let filter: TicketListRequest|undefined = this.state.listRequest;
        let today = new Date(new Date().setDate(new Date().getDate()+1)).toISOString().slice(0,10);
        let yesterday = new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10);
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7)).toISOString().slice(0,10);
        let thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-30)).toISOString().slice(0,10);

        switch(preset) {
            case "day":
                filter = { ...this.state.form, start_date: yesterday as any, end_date: today as any, searchByDate: true, searchString: ""};
                break;

            case "week":
                filter = { ...this.state.form, start_date: sevenDaysAgo as any, end_date: today as any, searchByDate: true, searchString: ""};
                break;

            case "month":
                filter = { ...this.state.form, start_date: thirtyDaysAgo as any, end_date: today as any, searchByDate: true, searchString: ""};
                break;
        }


        // this.updateListState({...filter});
        this.setState({form:filter})
    }

    getSearchByTicketId() {
        return(
            <div className="row">
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By User ID</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="requested_by">
                                <FormInput model={"requested_by"} className={"form-control"} />
                                <span className={"help-text"}>Finds a user by user id.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>
                </div>
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By Ticket ID</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="id">
                                <FormInput model={"id"} className={"form-control"} />
                                <span className={"help-text"}>Finds a ticket by ticket id. Use a character * for partial matches.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    getSearchByFilter() {

        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : false})}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : true})}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        &nbsp;
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-3">
                                    <FormGroup className={"form-group"} model="submitted_by">
                                        <label>Admin ID</label>
                                        <FormInput model={"submitted_by"} className={"form-control"} />
                                        <span className={"help-text"}>Finds a ticket by admin id.</span>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                        <label>Ticket created Date</label>
                                        <h5>Presets</h5>
                                        <div>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("day")}>Day</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("week")}>Week</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("month")}>Month</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"start_date"}>From:</label>
                                        <FormInput model={"start_date"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <label htmlFor={"end_date"}>To:</label>
                                        <FormInput model={"end_date"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-4">
                                    <FormGroup className="form-group">
                                        <label>Ticket Type</label>
                                        <SelectInput className="form-control  col-lg-4" model="types" size={[...Object.keys(TicketType)].length} multiple={true}
                                                     values={[...Object.keys(TicketType)]}
                                                     optional={true}
                                                     onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for ticket based on their Ticket Type. CTRL select for multiple types.  Select at least one</span>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                        <label>Ticket Status</label>
                                        <SelectInput className="form-control  col-lg-4" model="statuses" size={[...Object.keys(TicketStatus)].length} multiple={true}
                                                     values={[...Object.keys(TicketStatus)]}
                                                     optional={true}
                                                     onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for ticket based on their Ticket Status. CTRL select for multiple statuses. Select at least one</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-5">
                                    <FormGroup className="form-group">
                                        <label>Assigned</label>
                                        <SelectInput className="form-control  col-lg-4" model="groups" size={[...Object.keys(TicketGroup)].length} multiple={true}
                                            values={[...Object.keys(TicketGroup)]}
                                            optional={true}
                                            onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for ticket based on their Assigned. CTRL select for multiple values. Select at least one</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        )
    }

    clearForText() {
        let searchString:string | undefined = this.state.form && this.state.form.searchString;
        this.setState({form : {searchString:searchString}});
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form, searchString:""}})

    }

    clearFilter() {
        this.setState({form: {}})
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByTicketId()}
                {this.getSearchByFilter()}
                <EntityDataTable service={this.service}
                    onPagerChange={this.pagerChanged.bind(this)}
                    columns={this.columns}
                    listRequest={this.state.listRequest}
                    onAction={this.onAction.bind(this)}
                    actions={this.actions}
                    autoRefreshOptions={[10,30,60]}
                />
            </Fragment>
        );
    }



}

export default withRouter(TicketListView);

